import * as React from "react";
import { SVGProps } from "react";
const HamburgerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={13}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M1 12.518a.965.965 0 0 1-.712-.288.972.972 0 0 1-.288-.712c0-.283.095-.52.288-.712A.97.97 0 0 1 1 10.518h16c.283 0 .521.096.713.288.192.192.288.429.287.712 0 .282-.097.52-.288.713a.957.957 0 0 1-.712.287H1Zm0-5a.965.965 0 0 1-.712-.288A.972.972 0 0 1 0 6.518c0-.283.095-.52.288-.712A.97.97 0 0 1 1 5.518h16c.283 0 .521.096.713.288.192.192.288.429.287.712 0 .282-.097.52-.288.713a.957.957 0 0 1-.712.287H1Zm0-5a.965.965 0 0 1-.712-.288A.972.972 0 0 1 0 1.518c0-.283.095-.52.288-.712A.97.97 0 0 1 1 .518h16c.283 0 .521.096.713.288.192.192.288.429.287.712 0 .282-.097.52-.288.713a.957.957 0 0 1-.712.287H1Z"
    />
  </svg>
);
export default HamburgerIcon;
